import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  standalone: false,
  selector: "app-login-callback",
  templateUrl: "./login-callback.component.html",
  styleUrls: ["./login-callback.component.scss"],
})
export class LoginCallbackComponent implements OnInit {
  get routeQueryParamMap() {
    return this.activatedRouteSnapshot.queryParamMap;
  }

  get activatedRouteSnapshot() {
    return this.activatedRoute.snapshot;
  }

  get code() {
    return this.routeQueryParamMap.get('code');
  }

  get state() {
    return this.routeQueryParamMap.get('state');
  }

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    window.location.href = `opengroundcloud://callback/?code=${this.code}&state=${this.state}`;
  }
}
